// extracted by mini-css-extract-plugin
module.exports = {"timer":"_13720","item":"_17708","divider":"_18427","unit":"_2897"};